import gt from "ramda/src/gt";
import flip from "ramda/src/flip";

export const flipedGt1 = flip(gt)(1);
